require('./contractEasyLoanSidebar.scss');
require('./contractEasyLoanSidebar.override.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
//@core
const { formatText } = require('core/i18n').i18n;
//@components
const ContractLoanCompilationCard = require('../../contractLoanCompilationCard/contractLoanCompilationCard');
const ContractEasyLoanStepOneTooltip = require('../contractEasyLoanStepOneTooltip/contractEasyLoanStepOneTooltip');
//@utilities
const { getFormattedString, formatAmount, decimalsLength, formatNumber } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
//@constant
const { PERCENTAGE_SYMBOL } = require('constants/index');

class ContractEasyLoanSidebar extends React.Component {
    addPercentage(value) {
        return formatAmount(value, undefined, 2).concat(' ', PERCENTAGE_SYMBOL);
    }

    buildList() {
        const { immContractEasyLoan, immAccount } = this.props;
        let accountAlias, accountIban, accountBalance;
        if(immAccount){
        accountAlias = immAccount && immAccount.get('alias');
        accountIban = getLastNChars(immAccount.get('iban'));
        accountBalance = getFormattedString(immAccount.get('balance'));
        }

        const immOpeningCommission = immContractEasyLoan.get('openingCommission');
        const openingCommissionAmount = immOpeningCommission.get('amount');
        const openingCommissionMinAmount = immOpeningCommission.get('minimum');
        const percentage = immOpeningCommission.get('percentage');
        const showBothCommissions = immOpeningCommission.get('showPercentajeCommission') && immOpeningCommission.get('showMinCommission');
        const openingCommissionPercentage = percentage > 0 ? formatNumber(immOpeningCommission.get('percentage')) : percentage;

        let openingCommissionLabel;

        if (showBothCommissions) {
            const decimalLengthOpeningCommissionMin = decimalsLength(openingCommissionMinAmount);
            const openingCommissionMinFormatted = getFormattedString({
                amount: openingCommissionMinAmount,
                currency: immContractEasyLoan.get('currency'),
                decimalsLength: decimalLengthOpeningCommissionMin
            });

            openingCommissionLabel = [
                formatText('contractEasyLoanSidebar-openingCommissionWithPercentaje', [openingCommissionPercentage]),
                formatText('contractEasyLoanSidebar-openingCommissionMin', [openingCommissionMinFormatted])
            ];

        } else if (immOpeningCommission.get('showPercentajeCommission')) {
            openingCommissionLabel = formatText('contractEasyLoanSidebar-openingCommissionWithPercentaje', [openingCommissionPercentage]);
        } else {
            openingCommissionLabel = formatText('contractEasyLoanSidebar-openingCommission');
        }

        return [
            {
                label: openingCommissionLabel,
                text: getFormattedString({
                    amount: openingCommissionAmount,
                    currency: immContractEasyLoan.get('currency'),
                    decimalsLength: decimalsLength(openingCommissionAmount)
                }),
            },
            {
                label: formatText('contractEasyLoanSidebar-openingCommissionAmortizacion'),
                additionalLabel: <sup>1</sup>,
                className: 'contract-easy-loan-sidebar__list-separator'
            },
            {
                label: formatText('contractEasyLoanSidebar-associatedAccount'),
                text: !!immAccount ? `${accountAlias} ${accountIban}` : formatText('contractsView-toDefine'),
            },
            {
                label: formatText('contractEasyLoanSidebar-accountBalance'),
                text: !!immAccount ? `${accountBalance}` : formatText('contractsView-toDefine'),
            }
        ];
    }

    buildTaeTooltip() {
        const { immContractEasyLoan } = this.props;

        return (
            <ContractEasyLoanStepOneTooltip
                immContractEasyLoan={immContractEasyLoan}
                clarifyingText="clarifyingTextSidebar"
            />
        );
    }

    render() {
        const { immContractEasyLoan, location, isLoading } = this.props;
        const list = this.buildList();
        const taeTooltip = this.buildTaeTooltip();

        return (
            <ContractLoanCompilationCard
                immSummary={immContractEasyLoan}
                footerList={list}
                taeTooltip={taeTooltip}
                location={location}
                isLoading={isLoading}
            />
        );
    }
}

ContractEasyLoanSidebar.defaultProps = {
    isLoading: false,
}

ContractEasyLoanSidebar.propTypes = {
    immContractEasyLoan: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    tin: PropTypes.number.isRequired,
    location: PropTypes.object,
    isLoading: PropTypes.bool
};

module.exports = ContractEasyLoanSidebar;
